import { Injectable } from '@angular/core';
import { Organization } from '@core/core';
import { isTrustedRedirectUrl } from '@sdk/sdk';

@Injectable({
  providedIn: 'root'
})
export class OrganizationRedirectHelper {
  getRedirectUrl(
    organizations: Organization[],
    redirect: string
  ): string | null {
    let url: URL;
    try {
      url = new URL(redirect);
    } catch {
      return null;
    }
    const orgId = this._getOrgId(url);

    const foundOrgs = organizations.filter(
      organization => organization.url.host === url.host
    );

    if (foundOrgs.length == 1 && !orgId) {
      const organization = foundOrgs[0];
      return this.getOrganizationUrl(organization);
    }

    // Only return the raw redirect when it targets one of the user's own
    // organization hosts (covers multi-org-per-host and pre-resolved /o/{id}/
    // deep links, including the local-dev dummy org) or a trusted *.sytex.io
    // host. Any other absolute URL is an open-redirect attempt and is rejected.
    if (foundOrgs.length > 0 || isTrustedRedirectUrl(redirect)) {
      return redirect;
    }

    return null;
  }

  getOrganizationUrl(organization: Organization): string {
    return `${organization.url}o/${organization.id}/`;
  }

  getOrganizationFromUrl(
    organizations: Organization[],
    url: string
  ): Organization | undefined {
    return organizations.find(organization =>
      url.startsWith(this.getOrganizationUrl(organization))
    );
  }

  private _getOrgId(url: URL): string {
    // Get organization id from url
    const r = new RegExp(/^\/o\/(\d*)\//);

    if (r.test(url.pathname)) {
      const matches = r.exec(url.pathname);
      return matches![1];
    }

    return '';
  }
}
